import LogoWinelandStorefront from "@/assets/logos/wineland-storefront";
import { Button } from "@/components/ui/button";
import { getRoutes } from "@/utils/helpers";
import React from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

const AuthLayout: React.FC = () => {
  const navigate = useNavigate();
  const routes = getRoutes();
  const location = useLocation();
  const currentRoute = location.pathname;

  const formTitle =
    currentRoute === routes.signIn
      ? "Log in as vendor"
      : currentRoute === routes.forgotPassword
        ? "Trouble logging in?"
        : "Reset Password";

  const submitButtonText =
    currentRoute === routes.signIn
      ? "Sign In"
      : currentRoute === routes.forgotPassword
        ? "Send reset link"
        : "Submit";

  const submitButtonForm =
    routes.signIn === currentRoute
      ? "login-form"
      : currentRoute === routes.forgotPassword
        ? "forgot-password-form"
        : "reset-password-form";

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-gray-50 to-gray-200">
      <div className="w-full max-w-md flex flex-col items-center">
        <div className="mb-10">
          <LogoWinelandStorefront className="h-10 drop-shadow-md" />
        </div>
        <div className="bg-white p-10 rounded-2xl shadow-lg w-full border border-gray-200">
          <h2 className="text-2xl font-semibold mb-8 text-center text-gray-800 tracking-tight">
            {formTitle}
          </h2>

          <Outlet />
          <div className="flex flex-col gap-3 mt-4">
            <Button
              form={submitButtonForm}
              type="submit"
              variant="default"
              className="bg-wineland-primary hover:bg-wineland-primary/90 transition-colors shadow"
            >
              {submitButtonText}
            </Button>

            {currentRoute === routes.signIn && (
              <Button
                variant="link"
                type="button"
                className="text-sm text-gray-500 hover:text-wineland-primary"
                onClick={() => navigate(routes.forgotPassword)}
              >
                Forgot password?
              </Button>
            )}

            {currentRoute === routes.forgotPassword && (
              <Button
                variant="link"
                type="button"
                className="text-sm text-gray-500 hover:text-wineland-primary"
                onClick={() => navigate(routes.signIn)}
              >
                Back
              </Button>
            )}
          </div>
          {currentRoute === routes.signIn && (
            <div className="mt-4 text-center">
              <span className="text-xs text-gray-500">
                Not a vendor? Shop at{" "}
                <a
                  href="https://wineland.ge"
                  className="underline hover:text-wineland-primary"
                >
                  wineland.ge
                </a>
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
